/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_714cd67f"]'><div :class='[("theme-"+(themeType)+" them-container")]'><slot></slot></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_714cd67f"}'>
@require '../../themes/driver-variables.styl'
@require '../../themes/passenger-variables.styl'

.them-container
  height: 100%

</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_714cd67f"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_714cd67f"}
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex714cd67f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex714cd67f%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_714cd67f"],
    ctorType: "component",
    outputPath: "components/index714cd67f/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>